export default __webpack_public_path__ + "static/media/art-supplies.db41426c.jpg";